module.exports = __webpack_public_path__ + "static/media/bg-take-prize.090be3b0.png";